const conf = {
  "enemy": [
    "Terminid",
    "Automaton",
    "Illuminate"
  ],
  "difficulty": [
    "1 - Trivial or greater",
    "2 - Easy or greater",
    "3 - Medium or greater",
    "4 - Challenging or greater",
    "5 - Hard or greater",
    "6 - Extreme or greater",
    "7 - Suicide Mission or greater",
    "8 - Impossible or greater",
    "9 - Helldive or greater",
    "10 - Super Helldive"
  ],
  "difficultyWeights": [
    0.0200000000, // "1 - Trivial or greater"
    0.0700000000, // "2 - Easy or greater"
    0.0700000000, // "3 - Medium or greater"
    0.1200000000, // "4 - Challenging or greater"
    0.1200000000, // "5 - Hard or greater"
    0.1200000000, // "6 - Extreme or greater"
    0.1200000000, // "7 - Suicide Mission or greater"
    0.1200000000, // "8 - Impossible or greater"
    0.1200000000, // "9 - Helldive or greater"
    0.1200000000, // "10 - Super Helldive"
  ],
  "duration": [
    "10 minute or more",
    "12 minute or more",
    "15 minute or more",
    "20 minute or more",
    "40 minute"
  ],
  "durationWeights": [
    0.0500000000, // "10 minute or more"
    0.0500000000, // "12 minute or more"
    0.0500000000, // "15 minute or more"
    0.0500000000, // "20 minute or more"
    0.8000000000, // "40 minute"
  ],
  "teamplay": [
    "Solo",
    "Squad"
  ],
  "teamplayWeights": [
    0.2000000000, // "Solo"
    0.8000000000, // "Squad"
  ],
  "stars": [
    "0 stars or more",
    "1 stars or more",
    "2 stars or more",
    "3 stars or more",
    "4 stars or more",
    "5 stars"
  ],
  "primary": [
    "AR-23 Liberator",
    "AR-23A Liberator Carbine",
    "AR-23C Liberator Concussive",
    "AR-23P Liberator Penetrator",
    "AR-61 Tenderizer",
    "ARC-12 Blitzer",
    "BR-14 Adjudicator",
    "CB-9 Exploding Crossbow",
    "FLAM-66 Torcher",
    "JAR-5 Dominator",
    "LAS-16 Sickle",
    "LAS-5 Scythe",
    "MP-98 Knight",
    "Plas-1 Scorcher",
    "Plas-101 Purifier",
    "R-2124 Constitution",
    "R-36 Eruptor",
    "R-63 Diligence",
    "R-63CS Diligence Counter Sniper",
    "SG-20 Halt",
    "SG-225 Breaker",
    "SG-225IE Breaker Incendiary",
    "SG-225SP Breaker SPRAY&PRAY",
    "SG-451 Cookout",
    "SG-8 Punisher",
    "SG-8P Punisher Plasma",
    "SG-8S Slugger",
    "SMG-32 Reprimand",
    "SMG-37 Defender",
    "SMG-72 Pummeler",
    "StA-52 Assault Rifle",
    "StA-11 SMG",
    "PLAS-39 Accelerator Rifle",
    "LAS-17 Double-Edge Sickle",
    "R-6 Deadeye",
    "R-2 Amendment",
    "AR-32 Pacifier",
    "VG-70 Variable",
    "MA5C Assault Rifle",
    "M7S SMG",
    "M90A Shotgun",
    "AR-2 Coyote",
    "AR/GL-21 One-Two",
    "DBS-2 Double Freedom",
  ],
  "secondary": [
    "GP-31 Grenade Pistol",
    "LAS-7 Dagger",
    "P-2 Peacemaker",
    "P-4 Senator",
    "P-11 Stim Pistol",
    "P-19 Redeemer",
    "P-72 Crisper",
    "P-113 Verdict",
    "PLAS-15 Loyalist",
    "SG-22 Bushwhacker",
    "CQC-19 Stun Lance",
    "CQC-30 Stun Baton",
    "CQC-5 Combat Hatchet",
    "GP-31 Ultimatum",
    "LAS-58 Talon",
    "CQC-2 Saber",
    "P-92 Warrant",
    "M6C/SOCOM Pistol",
    "CQC-42 Machete",
  ],
  "grenade": [
    "G-3 Smoke",
    "G-4 Gas Grenade",
    "G-6 Frag",
    "G-10 Incendiary",
    "G-12 High Explosive",
    "G-13 Incendiary Impact",
    "G-16 Impact",
    "G-23 Stun",
    "G-123 Thermite",
    "K-2 Throwing Knife",
    "G-50 Seeker",
    "TED-63 Dynamite",
    "G-142 Pyrotech",
    "G-109 Urchin",
    "G-31 Arc",
    "G-7 Pineapple",
  ],
  "stratagem": [
    "A/AC-8 Autocannon Sentry",
    "A/ARC-3 Tesla Tower",
    "A/G-16 Gatling Sentry",
    "A/M-12 Mortar Sentry",
    "A/M-23 EMS Mortar Sentry",
    "A/MG-43 Machine Gun Sentry",
    "A/MLS-4X Rocket Sentry",
    "AC-8 Autocannon",
    "APW-1 Anti-Material Rifle",
    "ARC-3 Arc Thrower",
    "AX/AR-23 Guard Dog",
    "AX/TX-13 Guard Dog Dog Breath",
    "AX/LAS-5 Guard Dog Rover",
    "B-1 Supply Pack",
    "E/MG-101 HMG Emplacement",
    "Eagle 110m Rocket Pods",
    "Eagle 500kg Bomb",
    "Eagle Airstrike",
    "Eagle Cluster Bomb",
    "Eagle Napalm Airstrike",
    "Eagle Smoke Strike",
    "Eagle Strafing Run",
    "EAT-17 Expendable Anti-Tank",
    "EXO-45 Patriot Exosuit",
    "EXO-49 Emancipator Exosuit",
    "FAF-14 Spear",
    "FLAM-40 Flamethrower",
    "FX-12 Shield Generator Relay",
    "GL-21 Grenade Launcher",
    "GR-8 Recoilless Rifle",
    "LAS-98 Laser Cannon",
    "LAS-99 Quasar Cannon",
    "LIFT-850 Jump Pack",
    "M-105 Stalwart",
    "MD-6 Anti-Personnel Minefield",
    "MD-17 Anti-Tank Mines",
    "MD-I4 Incendiary Mines",
    "MG-206 Heavy Machine Gun",
    "MG-43 Machine Gun",
    "MLS-4X Commando",
    "Orbital 120MM HE Barrage",
    "Orbital 380MM HE Barrage",
    "Orbital Airburst Strike",
    "Orbital EMS Strike",
    "Orbital Gas Strike",
    "Orbital Gatling Barage",
    "Orbital Laser",
    "Orbital Napalm Barrage",
    "Orbital Precision Strike",
    "Orbital Railcannon Strike",
    "Orbital Smoke Strike",
    "Orbital Walking Barrage",
    "RL-77 Airburst Rocket Launcher",
    "RS-422 Railgun",
    "SH-20 Balistic Shield Backpack",
    "SH-32 Shield Generator Pack",
    "TX-41 Sterilizer",
    "SH-51 Directional Shield",
    "A/FLAM-40 Flame Sentry",
    "E/AT-12 Anti-Tank Emplacement",
    "M-102 Fast Recon Vehicle",
    "StA-X3 W.A.S.P. Launcher",
    "B-100 Portable Hellbomb",
    "MD-8 Gas Mines",
    "LIFT-860 Hover Pack",
    "E/GL-21 Grenadier Battlement",
    "CQC-1 One True Flag",
    "GL-52 De-Escalator",
    "AX/ARC-3 Guard Dog K-9",
    "Plas-45 Epoch",
    "A/LAS-98 Laser Sentry",
    "LIFT-182 Warp Pack",
    "MS-11 Solo Silo",
    "EAT-700 Expendable Napalm",
    "S-11 Speargun",
    "CQC-9 Defoliation Tool",
    "AZ/FLAM-75 Guard Dog Hot Dog",
    "M-1000 Maxigun",
  ],
  "stratagemWeights": [
    0.0061532648, // "A/AC-8 Autocannon Sentry"
    0.0061532648, // "A/ARC-3 Tesla Tower"
    0.0061532648, // "A/G-16 Gatling Sentry"
    0.0061532648, // "A/M-12 Mortar Sentry"
    0.0061532648, // "A/M-23 EMS Mortar Sentry"
    0.0061532648, // "A/MG-43 Machine Gun Sentry"
    0.0061532648, // "A/MLS-4X Rocket Sentry"
    0.0061532648, // "AC-8 Autocannon"
    0.0061532648, // "APW-1 Anti-Material Rifle"
    0.0061532648, // "ARC-3 Arc Thrower"
    0.0061532648, // "AX/AR-23 Guard Dog"
    0.0061532648, // "AX/TX-13 Guard Dog Dog Breath"
    0.0061532648, // "AX/LAS-5 Guard Dog Rover"
    0.0061532648, // "B-1 Supply Pack"
    0.0061532648, // "E/MG-101 HMG Emplacement"
    0.0061532648, // "Eagle 110m Rocket Pods"
    0.0061532648, // "Eagle 500kg Bomb"
    0.0061532648, // "Eagle Airstrike"
    0.0061532648, // "Eagle Cluster Bomb"
    0.0061532648, // "Eagle Napalm Airstrike"
    0.0061532648, // "Eagle Smoke Strike"
    0.0061532648, // "Eagle Strafing Run"
    0.0061532648, // "EAT-17 Expendable Anti-Tank"
    0.0061532648, // "EXO-45 Patriot Exosuit"
    0.0061532648, // "EXO-49 Emancipator Exosuit"
    0.0061532648, // "FAF-14 Spear"
    0.0061532648, // "FLAM-40 Flamethrower"
    0.0184597945, // "FX-12 Shield Generator Relay"
    0.0061532648, // "GL-21 Grenade Launcher"
    0.0061532648, // "GR-8 Recoilless Rifle"
    0.0061532648, // "LAS-98 Laser Cannon"
    0.0061532648, // "LAS-99 Quasar Cannon"
    0.0061532648, // "LIFT-850 Jump Pack"
    0.0061532648, // "M-105 Stalwart"
    0.0061532648, // "MD-6 Anti-Personnel Minefield"
    0.0061532648, // "MD-17 Anti-Tank Mines"
    0.0061532648, // "MD-I4 Incendiary Mines"
    0.0061532648, // "MG-206 Heavy Machine Gun"
    0.0061532648, // "MG-43 Machine Gun"
    0.0061532648, // "MLS-4X Commando"
    0.0061532648, // "Orbital 120MM HE Barrage"
    0.0061532648, // "Orbital 380MM HE Barrage"
    0.0061532648, // "Orbital Airburst Strike"
    0.0061532648, // "Orbital EMS Strike"
    0.0061532648, // "Orbital Gas Strike"
    0.0061532648, // "Orbital Gatling Barage"
    0.0061532648, // "Orbital Laser"
    0.0061532648, // "Orbital Napalm Barrage"
    0.0061532648, // "Orbital Precision Strike"
    0.0061532648, // "Orbital Railcannon Strike"
    0.0061532648, // "Orbital Smoke Strike"
    0.0061532648, // "Orbital Walking Barrage"
    0.0061532648, // "RL-77 Airburst Rocket Launcher"
    0.0061532648, // "RS-422 Railgun"
    0.2477156693, // "SH-20 Balistic Shield Backpack"
    0.0061532648, // "SH-32 Shield Generator Pack"
    0.0061532648, // "TX-41 Sterilizer"
    0.2723296732, // "SH-51 Directional Shield"
    0.0061532648, // "A/FLAM-40 Flame Sentry"
    0.0061532648, // "E/AT-12 Anti-Tank Emplacement"
    0.0061532648, // "M-102 Fast Recon Vehicle"
    0.0061532648, // "StA-X3 W.A.S.P. Launcher"
    0.0061532648, // "B-100 Portable Hellbomb"
    0.0061532648, // "MD-8 Gas Mines"
    0.0061532648, // "LIFT-860 Hover Pack"
    0.0061532648, // "E/GL-21 Grenadier Battlement"
    0.0061532648, // "CQC-1 One True Flag"
    0.0061532648, // "GL-52 De-Escalator"
    0.0061532648, // "AX/ARC-3 Guard Dog K-9"
    0.0061532648, // "Plas-45 Epoch"
    0.0061532648, // "A/LAS-98 Laser Sentry"
    0.0061532660, // "LIFT-182 Warp Pack"
    0.0061532648, // "MS-11 Solo Silo"
    0.0061532648, // "EAT-700 Expendable Napalm"
    0.0061532629, // "S-11 Speargun"
    0.0061532648, // "CQC-9 Defoliation Tool"
    0.0061532648, // "AZ/FLAM-75 Guard Dog Hot Dog"
    0.0061532685, // "M-1000 Maxigun"
  ],
  "BackpackStratagems": [
    "AC-8 Autocannon",
    "AX/AR-23 Guard Dog",
    "AX/TX-13 Guard Dog Dog Breath",
    "AX/LAS-5 Guard Dog Rover",
    "B-1 Supply Pack",
    "FAF-14 Spear",
    "FX-12 Shield Generator Relay",
    "GR-8 Recoilless Rifle",
    "LIFT-850 Jump Pack",
    "RL-77 Airburst Rocket Launcher",
    "SH-20 Balistic Shield Backpack",
    "SH-32 Shield Generator Pack",
    "SH-51 Directional Shield",
    "StA-X3 W.A.S.P. Launcher",
    "B-100 Portable Hellbomb",
    "LIFT-860 Hover Pack",
    "AX/ARC-3 Guard Dog K-9",
    "LIFT-182 Warp Pack",
    "M-1000 Maxigun",
    "AZ/FLAM-75 Guard Dog Hot Dog",
  ],
  "SupportWeaponStratagems": [
    "AC-8 Autocannon",
    "APW-1 Anti-Material Rifle",
    "ARC-3 Arc Thrower",
    "EAT-17 Expendable Anti-Tank",
    "FAF-14 Spear",
    "FLAM-40 Flamethrower",
    "GL-21 Grenade Launcher",
    "GR-8 Recoilless Rifle",
    "LAS-98 Laser Cannon",
    "LAS-99 Quasar Cannon",
    "M-105 Stalwart",
    "MG-206 Heavy Machine Gun",
    "MG-43 Machine Gun",
    "MLS-4X Commando",
    "RL-77 Airburst Rocket Launcher",
    "RS-422 Railgun",
    "TX-41 Sterilizer",
    "StA-X3 W.A.S.P. Launcher",
    "CQC-1 One True Flag",
    "GL-52 De-Escalator",
    "Plas-45 Epoch",
    "MS-11 Solo Silo",
    "EAT-700 Expendable Napalm",
    "S-11 Speargun",
    "CQC-9 Defoliation Tool",
    "M-1000 Maxigun",
  ],
  "MechStratagems": [
    "EXO-45 Patriot Exosuit",
    "EXO-49 Emancipator Exosuit"
  ],
  "OneHandedWeapons": [
    "MP-98 Knight",
    "SMG-37 Defender",
    "SMG-72 Pummeler",
    "StA-11 SMG",
    "CB-9 Exploding Crossbow",
    "CQC-1 One True Flag",
    "M7S SMG",
  ],
  "MeleeWeapons": [
    "R-2124 Constitution",
    "R-2 Amendment",
    "CQC-19 Stun Lance",
    "CQC-30 Stun Baton",
    "CQC-5 Combat Hatchet",
    "CQC-2 Saber",
    "K-2 Throwing Knife",
    "CQC-1 One True Flag",
    "CQC-42 Machete",
    "CQC-9 Defoliation Tool",
  ],
  "SmokeWeapons": [
    "G-3 Smoke",
    "Eagle Smoke Strike",
    "Orbital Smoke Strike",
  ],
  "SpawnerWeapons": {
    "Terminid": {
      "primary": [
        "CB-9 Exploding Crossbow",
        "R-36 Eruptor"
      ],
      "secondary": [
        "GP-31 Grenade Pistol"
      ],
      "grenade": [
        "G-6 Frag",
        "G-10 Incendiary",
        "G-12 High Explosive",
        "G-13 Incendiary Impact",
        "G-16 Impact",
        "G-123 Thermite",
        "TED-63 Dynamite",
        "G-142 Pyrotech",
        "G-7 Pineapple",
      ],
      "stratagem": [
        "AC-8 Autocannon",
        "EXO-45 Patriot Exosuit",
        "EXO-49 Emancipator Exosuit",
        "GL-21 Grenade Launcher",
        "GR-8 Recoilless Rifle",
        "LAS-99 Quasar Cannon",
        "MLS-4X Commando",
        "RL-77 Airburst Rocket Launcher",
        "StA-X3 W.A.S.P. Launcher",
        "S-11 Speargun",
      ]
    },
    "Automaton": {
      "primary": [
        "CB-9 Exploding Crossbow",
        "R-36 Eruptor"
      ],
      "secondary": [
        "GP-31 Grenade Pistol"
      ],
      "grenade": [
        "G-6 Frag",
        "G-10 Incendiary",
        "G-12 High Explosive",
        "G-13 Incendiary Impact",
        "G-16 Impact",
        "G-123 Thermite",
        "TED-63 Dynamite",
        "G-142 Pyrotech",
        "G-7 Pineapple",
      ],
      "stratagem": [
        "AC-8 Autocannon",
        "Eagle 110m Rocket Pods",
        "Eagle Napalm Airstrike",
        "Eagle 500kg Bomb",
        "Eagle Airstrike",
        "Eagle Strafing Run",
        "EAT-17 Expendable Anti-Tank",
        "EXO-45 Patriot Exosuit",
        "EXO-49 Emancipator Exosuit",
        "FAF-14 Spear",
        "GL-21 Grenade Launcher",
        "GR-8 Recoilless Rifle",
        "LAS-99 Quasar Cannon",
        "MLS-4X Commando",
        "Orbital 120MM HE Barrage",
        "Orbital 380MM HE Barrage",
        "Orbital Napalm Barrage",
        "Orbital Walking Barrage",
        "RL-77 Airburst Rocket Launcher",
        "StA-X3 W.A.S.P. Launcher",
        "EAT-700 Expendable Napalm",
        "S-11 Speargun",
      ]
    },
    "Illuminate": {
      "primary": [
        "CB-9 Exploding Crossbow",
        "R-36 Eruptor"
      ],
      "secondary": [
        "GP-31 Grenade Pistol"
      ],
      "grenade": [
        "G-6 Frag",
        "G-10 Incendiary",
        "G-12 High Explosive",
        "G-13 Incendiary Impact",
        "G-16 Impact",
        "G-123 Thermite",
        "TED-63 Dynamite",
        "G-142 Pyrotech",
        "G-7 Pineapple",
      ],
      "stratagem": [
        "AC-8 Autocannon",
        "Eagle 500kg Bomb",
        "Eagle Airstrike",
        "Eagle Strafing Run",
        "EAT-17 Expendable Anti-Tank",
        "EXO-45 Patriot Exosuit",
        "EXO-49 Emancipator Exosuit",
        "GL-21 Grenade Launcher",
        "GR-8 Recoilless Rifle",
        "LAS-99 Quasar Cannon",
        "MLS-4X Commando",
        "Orbital 120MM HE Barrage",
        "Orbital 380MM HE Barrage",
        "Orbital Walking Barrage",
        "RL-77 Airburst Rocket Launcher",
        "EAT-700 Expendable Napalm",
        "S-11 Speargun",
      ]
    }
  }
};

export default conf;
